export const getCompanyIndustries = () => [
  { label: "B2B", value: "B2B" },
  { label: "B2B2C", value: "B2B2C" },
  { label: "B2C", value: "B2C" },
];
